import { useState, useEffect } from 'react';
import { NavLink, Link } from 'react-router-dom';
import { FiShoppingCart } from 'react-icons/fi';
import { HiMenu, HiX } from 'react-icons/hi';
import { IoFlash } from 'react-icons/io5';
import logosz from "../assets/logosz.png";

import {
  MdHome, MdInventory2, MdBuildCircle, MdVerifiedUser, MdContactPhone
} from 'react-icons/md';

const links = [
  { to: '/',          label: 'Home',       icon: <MdHome /> },
  { to: '/products',  label: 'Products',   icon: <MdInventory2 /> },
  { to: '/services',  label: 'Services',   icon: <MdBuildCircle /> },
  { to: '/why-us',    label: 'Why Us',     icon: <MdVerifiedUser /> },
  { to: '/contact',   label: 'Contact Us', icon: <MdContactPhone /> },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const fn = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', fn);
    return () => window.removeEventListener('scroll', fn);
  }, []);

  const close = () => setMenuOpen(false);

  return (
    <>
      <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
        <div className="container">

          {/* ✅ Logo */}
          <Link to="/" className="nav-logo" onClick={close}>
            <div className="nav-logo-icon">
              <img src={logosz} alt="Spark Zone Logo" className="logo-img" />
            </div>
            <div>
              {/* <div className="nav-logo-text">SPARK ZONE</div>
              <div className="nav-logo-sub">Electrical Shop</div> */}
            </div>
          </Link>

          {/* Desktop links */}
          <ul className="nav-links">
            {links.map(l => (
              <li key={l.to}>
                <NavLink
                  to={l.to}
                  end={l.to === '/'}
                  className={({ isActive }) =>
                    `nav-link${isActive ? ' active' : ''}`
                  }
                >
                  {l.icon}
                  {l.label}
                </NavLink>
              </li>
            ))}
          </ul>

          {/* Right */}
          <div className="nav-cta-wrap">
            {/* <div className="nav-cart">
              <FiShoppingCart />
              <span className="nav-cart-count">4</span>
            </div> */}

            <Link to="/contact" className="nav-cta" onClick={close}>
              <IoFlash />
              Get Quote
            </Link>

            <button
              className="hamburger"
              onClick={() => setMenuOpen(p => !p)}
              aria-label="Toggle menu"
            >
              {menuOpen ? (
                <HiX style={{ fontSize: '1.3rem', color: 'var(--primary)' }} />
              ) : (
                <>
                  <span className="bar" />
                  <span className="bar" />
                  <span className="bar" />
                </>
              )}
            </button>
          </div>
        </div>
      </nav>

      {/* Mobile menu */}
      <div className={`mobile-nav${menuOpen ? ' open' : ''}`}>
        {links.map(l => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === '/'}
            className={({ isActive }) =>
              `nav-link${isActive ? ' active' : ''}`
            }
            onClick={close}
          >
            {l.icon}
            {l.label}
          </NavLink>
        ))}

        <div className="mobile-nav-footer">
          <Link
            to="/contact"
            className="btn-primary"
            onClick={close}
            style={{ flex: 1, justifyContent: 'center' }}
          >
            <IoFlash /> Get Free Quote
          </Link>
        </div>
      </div>
    </>
  );
}